import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useExportDonationsMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.ISystemJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			filterRequest,
			impersonationContext,
		}: {
			filterRequest: Api.IDonationFilterRequest;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'donation/export',
				}),
				'POST',
				filterRequest
			);
		},
		onError,
		onSuccess,
	});
};
